/**
 * User.update.order
 * User action to update order object in SDL
 * @param {object} order order object
 * @param {string} actionType action name
 * @returns {object} sdl object to push
 */
export default (order, actionType) => ({
	user: {
		update: {
			order,
			actionType
		}
	},
	order,
	event: 'user.update.order'
});
